var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"x-audio-wrap",class:{inline:!_vm.block},on:{"click":_vm.play}},[_c('div',{staticClass:"x-sector",class:{play:_vm.animate}},[_c('div',{staticClass:"x-dot"})]),_vm._v(" "),_c('div',{staticClass:"x-time"},[_vm._v(_vm._s(_vm.duration&&_vm.showDuration?_vm.duration:_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167bcf88","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/components/audio/audio.vue
// module id = null
// module chunks = 